/**
 * You can have several &lt;header&gt; elements in one document.The &lt;header&gt; element represents a container for introductory content or a set of navigational links.A &lt;header&gt; element typically contains:one or more heading elements (&lt;h1&gt; - &lt;h6&gt;)logo or icon
 *
 * @module views/Navigation/Header
 */

import React, { useState, useRef, useEffect } from "react";
import Ultalogo from "../../assets/image/Logo.svg";
import backArrow from "../../assets/image/back.svg";
import SalonImage from "../../assets/image/photo.svg";
import UserLogo from "../../assets/image/user-circle.svg";
import Spacer from "web-common-ssr/src/views/components/Spacer/Spacer";
import Image from "web-common-ssr/src/views/components/Image/Image";
import Link_Huge from "web-common-ssr/src/views/components/Link_Huge/Link_Huge";
import InflectionProvider from "web-common-ssr/src/views/__core/InflectionProvider/InflectionProvider";
import Flyout from "web-common-ssr/src/views/components/Flyout/Flyout";
import Button from "web-common-ssr/src/views/components/Button/Button";
import Text from "web-common-ssr/src/views/components/Text/Text";
import { getText, getFlatObject, useRouter, validatePath } from "../../utils/helper/helper";
import {
  getDashboardUserInfoData,
  getLogoutInfoData,
} from "../../actions/Dashboard/dashboardFlyout";
import FlyoutModal from "./FlyoutModal";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { useDeviceInflection } from "web-common-ssr/src/views/__core/InflectionProvider/InflectionProvider";
import bag from "../../assets/image/bagicon.svg";
import "./Header.scss";
import useReferralSource from "../../hooks/useReferralSource";

//import { Redirect } from "react-router-dom";

/**
 * Represents a Header component
 *
 * @method
 * @param {object} props - React properties passed from composition
 * @returns Header
 */
export const Header = (props) => {
  const { breakpoint } = useDeviceInflection();
const isSmallDevice = breakpoint.isSmallDevice();
  const { hederObj } = props;
 const noOfServices = getFlatObject(props.selectedServices).length;
  const history = useHistory();
  const location = useLocation();
  const { headerClass } = hederObj;
  const flyoutRef = useRef();
  const buttonRef = useRef();
  const [params, setParams] = useState({});
  const openFlyout = () => {
    flyoutRef.current.showModal();
    !props.dashboardFlyout?.firstName && props.getDashboardUserInfoData();
  };

  const { isReferralSource, resetReferralUser } = useReferralSource();
  const [isFlyoutModal, setIsFlyoutModal] = useState(false);
  const [isCartActive, setIsCartActive] = useState(false);
  const [notShowBagIcon, setNotShowBagIcon] = useState(true);
  const conditionForBagIcon = isSmallDevice &&  notShowBagIcon;
  const getRouter = useRouter();
  const popupModel = () => {
    if (
      window.location.href.indexOf("dashboard") > -1 ||
      window.location.href.indexOf("appointment/confirm") > -1 ||
      window.location.href.indexOf("store/search") > -1
    ) {
      setIsFlyoutModal(false);
      history.push("/dashboard");
    } else {
      setIsFlyoutModal((prev) => !prev);
    }
    flyoutRef.current.close();
  };
  const closePopup = () => {
    setIsFlyoutModal(false);
  };
  const handleCancelPopup = () => {
    setIsFlyoutModal(false);
    flyoutRef.current.showModal();
  };
  useEffect(()=>{
    if(flyoutRef.current){
      flyoutRef.current.setAttribute("aria-label","dialog My Dashboard")
    }
    
  },[isFlyoutModal,flyoutRef])
  useEffect(() => {
    //Only call if the user is authenticated or logged in

    if (
      props?.isAuthentication &&
      !props.dashboardFlyout?.firstName &&
      !props?.logout?.success
    ) {
      props.getDashboardUserInfoData();
    }
  }, [!props?.dashboardFlyout]);

  // useEffect(() => {
  //   if (
  //     !props?.isAuthentication &&
  //     props.dashboardFlyout?.userType === "P" &&
  //     !props?.logout?.success &&
  //     isSmallDevice
  //   ) {
  //     history.push("/login");
  //   }
  // }, [props?.dashboardFlyout]);

  // logout //
  const logOut = () => {
    props.getLogoutInfoData();
    flyoutRef.current?.close();
    // sessionStorage.clear();
    // localStorage.clear();
  };

  useEffect(() => {
    if (props?.logout?.success) {
      resetReferralUser();
      // Redirection To DSP Login Page
      history.push("/welcome");
      flyoutRef.current.close();
    }
  }, [props?.logout]);

  useEffect(()=> {
    if (validatePath(history?.location?.pathname)) {
      setNotShowBagIcon(false);
    }
    else {
      setNotShowBagIcon(true);
    }
  }, [history?.location?.pathname]);

  useEffect(() => {
    setParams(getRouter);
    if (history?.location?.pathname.includes('/services/') || history?.location?.state?.lastCategoryID) {
      setParams({
        ...getRouter, lastCategoryID: history?.location?.state?.lastCategoryID || history?.location?.state?.categoryID,
        lastCategoryName: history?.location?.state?.lastCategoryName || history?.location?.state?.categoryName,
        lastPathname: history?.location?.state?.lastCategoryID ? history?.location?.state?.lastPathname : history?.location?.pathname,
        lastTeammateId: history?.location?.state?.lastTeammateId || history?.location?.state?.TeammateId,
        lastDisplayName: history?.location?.state?.lastDisplayName || history?.location?.state?.displayName,
      })
    }
  }, [history?.location?.pathname]);

  useEffect(() => {
    // set the cart icon active on mobile device only when store is selected else keep disabled
    if(props?.selectedStore == null) {
      setIsCartActive(false);
    } else {
      setIsCartActive(true);
    }
  }, [props?.selectedStore]);

  /** Mathod Triggered On-Click Of Cart Icon */
  const handleCartOnClick = () => {
    const currentLocation = history?.location?.pathname;
    /** If Already On Same Page Then Avoid Re-load */
    if(currentLocation != '/appointmentCard') {
      history.push("/appointmentCard", params)
    }
  }

  const closeAccessibilityAction={
    label:"close"
  }

  return (
    <>
      {isFlyoutModal && (
        <FlyoutModal
          closePopup={closePopup}
          handleCancelPopup={handleCancelPopup}
        />
      )}

      {/* {props?.logout?.success && (
         <Redirect
           push
           to={{
             pathname: "/login",
           }}
         />
       )} */}
      <InflectionProvider>
      <header className={`Header-custom ${headerClass ? headerClass : ""}`}>
      <nav className="Header-Nav">
            <div className="Grid">
              <div className="fullGrid">
                <div className="component">
                  <div className="BackArrow">
                    <Link_Huge
                      url="https://www.ulta.com/beautyservices/all"
                      className="back-button"
                    >
                      <img src={backArrow} alt="" />
                      <span>EXIT</span>
                    </Link_Huge>
                  </div>
                </div>
                <div className="component spanMinusTwo">
                  <img
                    src={Ultalogo}
                    alt="Ulta Beauty"
                    className="Image__Responsive"
                  />
                </div>
                <div className="component">
                  {props.dashboardFlyout?.firstName &&
                    props.dashboardFlyout?.userType !== "P" && (
                      <button
                        onClick={() => openFlyout()}
                        className="Button-ds User-circle Button-ds--clear Button-ds--icon"
                      >
                        <img
                          src={UserLogo}
                          title="My Dashboard"
                          alt=" My dashboard"
                          ref={buttonRef}
                        />
                      </button>
                    )}
                   {conditionForBagIcon ? <button
                        className={ "Button-ds Button-ds--clear Button-ds--icon bag"}
                        onClick = {handleCartOnClick}
                        disabled = {!isCartActive}
                      >
                        <img
                          src={bag}
                          title="Shopping Bag"
                          alt="shopping bag"
                        />
                      {noOfServices >0 ? <div><div className="circle"></div>
<p className={"servicesText"}>{noOfServices}</p></div>: null}
                      </button>: null} 
                </div>
              </div>
            </div>
          </nav>
        </header>

        <Flyout ref={flyoutRef} opener={buttonRef} closeAccessibilityAction={closeAccessibilityAction} >
          <div aria-hidden="true">
            <div className="pastappointments-title">
              <div className="flyout-container">
                <div className="round-img">
                  <Image src={UserLogo} width={56} height={56} />
                </div>
                <div>
                  <Text htmlTag="h1" textStyle="title-5">
                    {getText("dashboard.hi")} {props.dashboardFlyout?.firstName}
                    !
                  </Text>
                  <Spacer title="Spacer" value="01" />
                  <Text htmlTag="p" textStyle="body-1">
                    {props.dashboardFlyout?.phoneNumber}
                  </Text>
                </div>
              </div>
            </div>
            <Spacer title="Spacer" value="02" />
            {!location.pathname.match(/dashboard/) && (
              <Button
                onClick={() => popupModel()}
                label="Go to Dashboard"
                className="gotoDashboard-text"
              />
            )}
            <Spacer title="Spacer" value="03" />
            <div className="log-out-btn">
              <Button
                label={getText("dashboard.logout")}
                onClick={() => logOut()}
              />
            </div>
          </div>
        </Flyout>
      </InflectionProvider>
    </>
  );
};

/**
 * Property type definitions
 *
 * @type {object}
 * @property {string} hederObj - Sets label for the menu icon
 */
const propTypes = {
  hederObj: PropTypes.object,
};

Header.propTypes = propTypes;

const mapStateToProps = (state) => ({
  dashboardFlyout: state?.dashboardFlyout?.usrInfo?.response,
  logout: state?.dashboardFlyout?.logout,
  isAuthentication: state?.authentication?.pin,
  selectedServices: state?.appointments?.selectedServices,
  selectedStore: state.appointments?.selectedStore
});
const mapDispatchToProps = (dispatch) => ({
  getDashboardUserInfoData: () => {
    dispatch(getDashboardUserInfoData());
  },
  getLogoutInfoData: () => {
    dispatch(getLogoutInfoData());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
